import { UploadSurveyRequest } from './survey.types';

import { API_HOST, HttpPostOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = (externalReference: string) => `${API_HOST}/programmes/${externalReference}/surveys`;

export const getUploadSurveyRequest = (data: UploadSurveyRequest): [string, HttpPostOptions<{ data: string }>] => [
  `${getEndpoint(data.programmeExternalReference)}/upload`,
  getHttpPostOptions({ data: data.data })
];
